<script setup lang="ts">
/** 滑杆（连续输入由 op 的 mergeKey 合并成一条 undo） */
const props = defineProps<{
  value: number;
  min: number;
  max: number;
  step?: number;
  /** 位置锁拦下时禁用（滑杆拖了没反应最糟，直接禁用） */
  disabled?: boolean;
  /** 稳定标识（供测试与调试定位，渲染成 data-field） */
  name?: string;
}>();
const emit = defineEmits<{ change: [value: number] }>();
</script>

<template>
  <div class="slider-row">
    <input
      type="range"
      :data-field="props.name"
      :min="props.min"
      :max="props.max"
      :step="props.step ?? 1"
      :value="props.value"
      :disabled="props.disabled === true"
      @input="emit('change', Number(($event.target as HTMLInputElement).value))"
    />
  </div>
</template>
